var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRetry(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 73.489,
    height: 73.489,
    viewBox: "0 0 73.489 73.489",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4554",
    "data-name": "Group 4554",
    transform: "translate(-674 -647)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2361",
    "data-name": "Path 2361",
    d: "M36.744,0A36.744,36.744,0,1,1,0,36.744,36.744,36.744,0,0,1,36.744,0Z",
    transform: "translate(674 647)",
    fill: "#0076bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2360",
    "data-name": "Path 2360",
    d: "M40.276,12.254C35.144,1.579,21.723-2.3,11.266,3.153A1.746,1.746,0,1,0,12.9,6.239c8.734-4.546,19.882-1.3,24.192,7.545,5.718,11.742-1.661,20.7-7.642,24.009-8.14,4.52-18.466,1.521-23.4-6.181l6.059,1.268a1.764,1.764,0,0,0,.726-3.454L2.1,27.24a1.817,1.817,0,0,0-2.09,2L1.378,40.066a1.7,1.7,0,0,0,1.731,1.548,1.862,1.862,0,0,0,1.731-2.09l-.525-4.415c5.019,6.19,14.89,11.471,26.876,5.963C36.272,38.449,47.935,28.158,40.276,12.254Z",
    transform: "translate(690.229 662.184)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetry);
export default __webpack_public_path__ + "static/media/retry.af2b65d7.svg";
export { ForwardRef as ReactComponent };